module.exports = __webpack_public_path__ + "media/images/AMSALE_RTW-b174af2d.webp";